import React from "react";
import PropTypes from "prop-types";

//  mui
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import DialogContentText from "@mui/material/DialogContentText";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

// component
import ButtonMain from "../button/ButtonMain";


const MsgDialog = ({
  setOpen,
  open,
  src,
  alt,
  dialogTitleText,
  dialogContentText,
  dialogActionYes,
  dialogActionNo,
  action,
  handleConfirm,
  handleCancel,
}) => {
  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open}>
      <IconButton
        aria-label="close"
        onClick={handleOpen}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      {dialogTitleText && (
        <DialogTitle
          sx={{
            fontWeight: "700",
            fontSize: "20px",
            lineHeight: "28.96px",
            textAlign: "center",
            padding: "40px 24px 24px 24px",
          }}
        >
          {dialogTitleText}
        </DialogTitle>
      )}
      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          {dialogContentText && (
            <DialogContentText sx={{ color: "#000" }}>
              {dialogContentText}
            </DialogContentText>
          )}
          {src && alt && <img src={src} alt={alt} height={200} width={200} />}
        </Box>
      </DialogContent>
      {action && (
        <DialogActions sx={{ padding: "0px 24px 20px 24px" }}>
          <Grid container columnGap={1}>
            {dialogActionNo && (
              <Grid item xs>
                <ButtonMain
                  buttonProps={{
                    fullWidth: true,
                    variant: "feedback",
                    text: dialogActionNo,
                    onClick: handleCancel,
                    sx: {
                      width: "100%",
                      padding: "8px 24px",
                      borderRadius: "8px",
                    },
                  }}
                />
              </Grid>
            )}
            {dialogActionYes && (
              <Grid item xs>
                <ButtonMain
                  buttonProps={{
                    fullWidth: true,
                    variant: "linearGradient",
                    text: dialogActionYes,
                    sx: { width: "100%" },
                    onClick: handleConfirm,
                  }}
                />
              </Grid>
            )}
          </Grid>
        </DialogActions>
      )}
    </Dialog>
  );
};

MsgDialog.propTypes = {
  // 對話框開關
  setOpen: PropTypes.func,
  open: PropTypes.bool,
  // 圖片
  src: PropTypes.string,
  // 圖片說明
  alt: PropTypes.string,
  // 對話框是否有按鈕
  action: PropTypes.bool,
  // 確認執行...
  handleConfirm: PropTypes.func,
  // 取消執行...
  handleCancel: PropTypes.func,
  // 對話框標題
  dialogTitleText: PropTypes.string,
  // 對話框文字內容
  dialogContentText: PropTypes.string,
  // 對話框「確認」文字內容
  dialogActionYes: PropTypes.string,
  // 對話框「取消」文字內容
  dialogActionNo: PropTypes.string,

};

MsgDialog.defaultProps = {
  // 對話框開關
  setOpen: () => null,
  open: false,
  // 圖片
  src: "",
  // 圖片說明
  alt: "",
  // 對話框是否有按鈕
  action: false,
  // 確認執行...
  handleConfirm: () => null,
  // 取消執行...
  handleCancel: () => null,
  // 對話框標題
  dialogTitleText: "",
  // 對話框文字內容
  dialogContentText: "",
  // 對話框「確認」文字內容
  dialogActionYes: "",
  // 對話框「取消」文字內容
  dialogActionNo: "",
};
export default MsgDialog;
